import styled from 'styled-components';

export const AttachmentContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey4};
  border-radius: 8px;
  padding: 8px 16px;

  min-width: 260px;
  max-width: 260px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FileName = styled.span`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;
  background-color: ${({ theme }) => theme.colorPalette.turquoise.accent2};
`;
